export const MODULES = {
    DASHBOARD: "DASHBOARD",
    MASTERS: "MASTERS",
    VENDORS: "VENDORS",
    PR: "PR",
    RFQ: "RFQ",
    PO: "PO",
    PURCHASE_ORDERS: "PURCHASE_ORDERS",
    INVOICES: "INVOICES",
    PO_PAYMENT_SUMMARY: "PO_PAYMENT_SUMMARY",
    NOTIFICATION: "NOTIFICATION",
    APPROVALS: "APPROVALS",
    APPROVALS_FLOW: "APPROVALS_FLOW",
    ROLES: "ROLES",
    MODULES: "MODULES",
    USERS: "USERS",
    MDMREPORTS: "MDMREPORTS",
    QUOTATIONS: "QUOTATIONS",
    SHIPMENTS: "SHIPMENTS",
    SERVICE_DELIVERY: "SERVICE_DELIVERY",
    ROLE_COUNTRY_MAPPING: "ROLE_COUNTRY_MAPPING",
    APPROVAL_THRESHOLD: "APPROVAL_THRESHOLD",
    INVOICE_PARKING: "INVOICE_PARKING",
};

export const ACTIONS = {
    VIEW: "VIEW",
    /** List scope: records created by the logged-in user (PR / RFQ / PO) */
    VIEW_OWN: "VIEW_OWN",
    /** List scope: records for company codes mapped from the user's countries */
    VIEW_BY_COMPANY_CODE: "VIEW_BY_COMPANY_CODE",
    /** List scope: records for plants assigned to the logged-in user */
    VIEW_BY_PLANT: "VIEW_BY_PLANT",
    /** List scope: all records (no user / company restriction) */
    VIEW_ALL: "VIEW_ALL",
    /** Show "My awaiting actions" list tab */
    VIEW_AWAITING: "VIEW_AWAITING",
    /** Vendor quotations: Grouped by RFQ list tab */
    VIEW_GROUPED: "VIEW_GROUPED",
    /** Vendor quotations: flat list filtered by vendors mapped to the user */
    VIEW_VENDOR_LIST: "VIEW_VENDOR_LIST",
    /** Purchase orders: list/view POs for vendors mapped to the logged-in user */
    VIEW_BY_VENDOR: "VIEW_BY_VENDOR",
    /** Purchase orders: Finance inbox — APPROVED + FINANCE_APPROVED only */
    VIEW_FINANCE: "VIEW_FINANCE",
    /** Vendor quotations: compare submitted offers */
    COMPARE: "COMPARE",
    /** Vendor quotations: submit / resubmit quotation */
    SUBMIT_FOR_APPROVAL: "SUBMIT_FOR_APPROVAL",
    /** Vendor quotations: request revision from vendor (buyer action) */
    REQUEST_REVISION: "REQUEST_REVISION",
    ADD: "ADD",
    /** Clone an existing record */
    CLONE: "CLONE",
    EDIT: "EDIT",
    DELETE: "DELETE",
    CANCEL: "CANCEL",
    APPROVE: "APPROVE",
    REJECT: "REJECT",
    /** Purchase orders: Finance approve / reject (separate from hierarchy approval) */
    FINANCE_APPROVE: "FINANCE_APPROVE",
    FORWARD: "FORWARD",
    DOWNLOAD_REPORT: "DOWNLOAD_REPORT",
    UPLOAD: "UPLOAD",
    PRINT: "PRINT",
    PUSH_TO_SAP: "PUSH_TO_SAP",
    DISABLE_PUSH_TO_SAP_BTN: "DISABLE_PUSH_TO_SAP_BTN",
    SUBMIT_APPROVAL: "SUBMIT_APPROVAL",
    APPROVAL_ACTION: "APPROVAL_ACTION",
    SUBMIT_REVIEW: "SUBMIT_REVIEW",
    BLOCK_UNBLOCK: "BLOCK_UNBLOCK",
    ACTIVE_INACTIVE: "ACTIVE_INACTIVE",
    PERMISSIONS: 'PERMISSIONS',
    CUSTOMIZE_COLUMNS: 'CUSTOMIZE_COLUMNS',
    SEND_FOR_APPROVAL: 'SEND_FOR_APPROVAL',
    QUOTATION_VIEW_DETAILS: 'QUOTATION_VIEW_DETAILS',
    DOCUMENT_FLOW: 'DOCUMENT_FLOW',
    CANCEL_GRN: 'CANCEL_GRN',
    /** Shipments / Service Delivery: review submitted GRN (received qty, storage, batch, serial) */
    REVIEW: 'REVIEW',
    /**
     * Shipments / Service Delivery: create with shipped + received qty.
     * Submit calls SUBMITTED then REVIEWED. Does not replace ADD or REVIEW.
     */
    CREATE_AND_REVIEW: 'CREATE_AND_REVIEW',
};

export const ROLE_NAMES = {
    SUPER_ADMIN: "SUPER_ADMIN",
    GLP_MANAGER: "GLP_MANAGER",
    FINANCE_POAPPROVER: "FINANCE_POAPPROVER",
}
